/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    RolesPage,
    RolesPageFromJSON,
    RolesPageToJSON,
} from '../models';

export interface FindAllRolesRequest {
    organisationId?: number;
    page?: number;
    size?: number;
    onlyAssignableToFilter?: boolean;
}

/**
 * 
 */
export class RoleApi extends runtime.BaseAPI {

    /**
     * Fetches all roles
     */
    async findAllRolesRaw(requestParameters: FindAllRolesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<RolesPage>> {
        const queryParameters: any = {};

        if (requestParameters.organisationId !== undefined) {
            queryParameters['organisationId'] = requestParameters.organisationId;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        if (requestParameters.onlyAssignableToFilter !== undefined) {
            queryParameters['onlyAssignableToFilter'] = requestParameters.onlyAssignableToFilter;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/roles`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RolesPageFromJSON(jsonValue));
    }

    /**
     * Fetches all roles
     */
    async findAllRoles(requestParameters: FindAllRolesRequest = {}, initOverrides?: RequestInit): Promise<RolesPage> {
        const response = await this.findAllRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
